import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { formatNumber, formatPercent } from '../../utils/format';
import type { BlandFunnel as Funnel } from '../../types/voip';
interface BlandFunnelProps {
  funnel: Funnel;
  scopeLabel: string;
}
export function BlandFunnel({
  funnel,
  scopeLabel
}: BlandFunnelProps) {
  const rate = (n: number, d: number) => d === 0 ? 0 : n / d;
  const stages = [{
    label: 'Dials',
    value: funnel.dials,
    note: `AI dialer, ${scopeLabel}`,
    conversion: null
  }, {
    label: 'Picked up',
    value: funnel.pickedUp,
    note: 'of dials',
    conversion: rate(funnel.pickedUp, funnel.dials)
  }, {
    label: 'Transferred to LO',
    value: funnel.transferred,
    note: 'of pickups',
    conversion: rate(funnel.transferred, funnel.pickedUp)
  }, {
    label: 'Opportunities created',
    value: funnel.opportunities,
    note: 'of transfers',
    conversion: rate(funnel.opportunities, funnel.transferred)
  }];
  return <section aria-label="Bland AI dialer funnel" className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card" data-id="element-1" data-mp="2n1hjj868imt3">
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4" data-id="element-2" data-mp="3qj4f72iho6f">
        {stages.map((s, i) => {
        const last = i === stages.length - 1;
        return <li key={s.label} className={`relative flex flex-col p-6 ${last ? 'bg-src-bland text-on-accent' : 'border-b border-line sm:odd:border-r lg:border-b-0 lg:border-r'}`} data-id="element-3" data-mp="cq5uiwpsj7k6" data-mpi={i}>
              <p className={`text-sm font-medium ${last ? 'text-on-accent/85' : 'text-muted'}`} data-id="element-4" data-mp="mlpm56xbnk34">{s.label}</p>
              <p className={`mt-2 font-display text-[34px] font-bold leading-none tracking-tight ${last ? 'text-on-accent' : 'text-ink'}`} data-id="element-5" data-mp="hmd0gpi6sj24">
                {formatNumber(s.value)}
              </p>
              <p className={`mt-3 text-xs ${last ? 'text-on-accent/85' : 'text-muted'}`} data-id="element-6" data-mp="rgdejgvg4ymz">
                {s.conversion === null ? s.note : <>
                    <span className={`font-semibold ${last ? 'text-on-accent' : 'text-ink'}`} data-id="element-7" data-mp="10d4a7s636bh1">{formatPercent(s.conversion)}</span> {s.note}
                  </>}
              </p>
              {s.conversion !== null && <div className={`mt-2 h-1.5 overflow-hidden rounded-full ${last ? 'bg-on-accent/25' : 'bg-canvas'}`} aria-hidden data-id="element-8" data-mp="71z4zly3xidr">
                  <div className={`h-full rounded-full ${last ? 'bg-on-accent' : 'bg-src-bland'}`} style={{
              width: `${Math.min(100, s.conversion * 100)}%`
            }} data-id="element-9" data-mp="buihefl267gz" />
                </div>}
              {!last && <span className="absolute -right-3 top-1/2 z-10 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-surface text-subtle lg:flex" aria-hidden data-id="element-10" data-mp="lt7za8cyfrx8">
                  <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-11" data-mp="upfp41b7y6tm" />
                </span>}
            </li>;
      })}
      </ol>
      <p className="border-t border-line px-6 py-3 text-xs text-muted" data-id="element-12" data-mp="2widdnkxyqd8r">
        <span className="font-semibold text-ink" data-id="element-13" data-mp="2ozdt3byrmfnt">{formatPercent(funnel.dials === 0 ? 0 : funnel.opportunities / funnel.dials)}</span> of all dials became an
        opportunity
      </p>
    </section>;
}